import request from '@/utils/request';
const { VUE_APP_LAOSHIBANG } = process.env;

export function getApplicationList(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/app/index/list',
    method: 'post',
    data: { ...params }
  });
}

export function addMyAppList(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/aitalk/mylist/add',
    method: 'post',
    data: { ...params }
  });
}

export function addAiassistantList(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/aiassistant/mylist/add',
    method: 'post',
    data: { ...params }
  });
}

export function getAiassistantInfo(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/aiassistant/info',
    method: 'post',
    data: { ...params }
  });
}

// 应用搜索
export function appSearch(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/app/search',
    method: 'post',
    data: { ...params }
  });
}

// 获取推荐应用列表
export function getRecommendAppList(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/app/recommend',
    method: 'get',
    data: { ...params }
  });
}

// 获取AB测试
export function getABTest(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/user/abtest',
    method: 'POST',
    data: { ...params }
  });
}